import AppUserService from 'src/modules/appUser/appUserService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'APPUSER_FORM';

// Mirrors the backend default (appUserRepository.DEFAULT_APP_USER_PASSWORD):
// when an app user is created without a password (and isn't a template), the
// backend assigns this. Kept in sync manually — the two live in separate repos.
const DEFAULT_APP_USER_PASSWORD = '123456';

const appUserFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: appUserFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AppUserService.find(id);
      }

      dispatch({
        type: appUserFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: appUserFormActions.INIT_ERROR,
      });

      getHistory().push('/app-user');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: appUserFormActions.CREATE_STARTED,
      });

      await AppUserService.create(values);

      dispatch({
        type: appUserFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.appUser.create.success'),
      );

      // The admin left the password blank for a real user → the backend assigned
      // the default. Surface it so they can pass the credential to the user.
      if (!values.isTemplate && !values.password) {
        Message.info(
          i18n(
            'entities.appUser.create.defaultPasswordAssigned',
            DEFAULT_APP_USER_PASSWORD,
          ),
        );
      }

      getHistory().push('/app-user');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: appUserFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: appUserFormActions.UPDATE_STARTED,
      });

      await AppUserService.update(id, values);

      dispatch({
        type: appUserFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.appUser.update.success'),
      );

      getHistory().push('/app-user');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: appUserFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default appUserFormActions;
